var chunkMapping = {
	"0": [
		4652
	],
	"3": [
		4058,
		4351
	],
	"79": [
		5088
	],
	"164": [
		5175
	],
	"165": [
		5176
	],
	"168": [
		5179
	],
	"169": [
		5180
	],
	"170": [
		5181
	],
	"171": [
		5182
	],
	"172": [
		5183
	],
	"173": [
		5184
	],
	"174": [
		5185
	],
	"175": [
		5186
	],
	"176": [
		5187
	],
	"177": [
		5188
	],
	"178": [
		5189
	],
	"179": [
		5190
	],
	"180": [
		5191
	],
	"181": [
		5192
	],
	"182": [
		5193
	],
	"183": [
		5194
	],
	"184": [
		5195
	],
	"185": [
		5196
	],
	"186": [
		5197
	],
	"187": [
		5198
	]
};
var idToExternalAndNameMapping = {
	"4058": [
		"default",
		"./nuorder-components",
		3672
	],
	"4351": [
		"default",
		"./helios-components",
		3672
	],
	"4652": [
		"default",
		"./Containers",
		3582
	],
	"5088": [
		"default",
		"./OrderlessInvoices",
		3582
	],
	"5175": [
		"default",
		"./AsyncEventTracker",
		3582
	],
	"5176": [
		"default",
		"./HostWrapper",
		3582
	],
	"5179": [
		"default",
		"./CheckoutV3",
		3582
	],
	"5180": [
		"default",
		"./CheckoutConfirmation",
		3582
	],
	"5181": [
		"default",
		"./ContactCreditCards",
		3582
	],
	"5182": [
		"default",
		"./AuditDialog",
		3582
	],
	"5183": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3582
	],
	"5184": [
		"default",
		"./InvoiceDialog",
		3582
	],
	"5185": [
		"default",
		"./PaymentDueModal",
		3582
	],
	"5186": [
		"default",
		"./PaymentModal",
		3582
	],
	"5187": [
		"default",
		"./PaymentHistory",
		3582
	],
	"5188": [
		"default",
		"./PaymentConfigurations",
		3582
	],
	"5189": [
		"default",
		"./PaymentPreferences",
		3582
	],
	"5190": [
		"default",
		"./ManagePaymentProcessing",
		3582
	],
	"5191": [
		"default",
		"./MobilePaymentsWrapper",
		3582
	],
	"5192": [
		"default",
		"./PayPage",
		3582
	],
	"5193": [
		"default",
		"./Challenge",
		3582
	],
	"5194": [
		"default",
		"./ManagePaymentMethods",
		3582
	],
	"5195": [
		"default",
		"./LightspeedReports",
		3582
	],
	"5196": [
		"default",
		"./ActivateLightspeedPayments",
		3582
	],
	"5197": [
		"default",
		"./MarketingLandingPage",
		3582
	],
	"5198": [
		"default",
		"./ShippingPromotionsListContainer",
		3582
	]
};
var idToRemoteMap = {
	"4058": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3672
		}
	],
	"4351": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3672
		}
	],
	"4652": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5088": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5175": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5176": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5179": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5180": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5181": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5182": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5183": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5184": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5185": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5186": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5187": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5188": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5189": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5190": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5191": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5192": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5193": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5194": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5195": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5196": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5197": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5198": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}